import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { backOfficeUserRegistry } from '@root/entities/back-office/back-office-user'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

interface BackOfficeUsersListRequestData {
  cursor?: string
  limit?: number
  query?: string
  blocked?: boolean
}

export const reatomBackOfficeUsersListRequestAction = action(
  async (ctx, data: BackOfficeUsersListRequestData) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.admin.adminUsersList, [data]),
    )

    const mappedResult = result.pipe(
      Result.map((it) => ({
        data: it.data.map((dto) =>
          backOfficeUserRegistry.resolveFromDto({
            dto,
            avatarsHost: assets.avatarsHost,
            imagesHost: assets.tokenLogosHost,
          }),
        ),
        meta: it.meta,
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'reatomBackOfficeUsersListRequestAction',
)
